'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DownArrowIcon = function DownArrowIcon(props) {
	return _react2.default.createElement(
		'svg',
		props,
		_react2.default.createElement(
			'g',
			{
				fill: '#3F5060',
				fillRule: 'evenodd'
			},
			_react2.default.createElement('rect', {
				transform: 'rotate(-45 4.464 4.464)',
				x: '3.464',
				y: '-.536',
				width: '2',
				height: '10',
				rx: '1'
			}),
			_react2.default.createElement('rect', {
				transform: 'rotate(45 10.103 4.452)',
				x: '9.103',
				y: '-.548',
				width: '2',
				height: '10',
				rx: '1'
			})
		)
	);
};

DownArrowIcon.defaultProps = {
	width: '15',
	height: '9',
	viewBox: '0 0 15 9',
	xmlns: 'http://www.w3.org/2000/svg'
};

var LeftArrowIcon = function LeftArrowIcon(props) {
	return _react2.default.createElement(
		'svg',
		props,
		_react2.default.createElement(
			'g',
			{
				transform: 'rotate(90 4.5 4.5)',
				fill: '#3F5060',
				fillRule: 'evenodd'
			},
			_react2.default.createElement('rect', {
				transform: 'rotate(-45 4.464 4.464)',
				x: '3.464',
				y: '-.536',
				width: '2',
				height: '10',
				rx: '1'
			}),
			_react2.default.createElement('rect', {
				transform: 'rotate(45 10.103 4.452)',
				x: '9.103',
				y: '-.548',
				width: '2',
				height: '10',
				rx: '1'
			})
		)
	);
};

LeftArrowIcon.defaultProps = {
	width: '9',
	height: '15',
	viewBox: '0 0 9 15',
	xmlns: 'http://www.w3.org/2000/svg'
};

var RightArrowIcon = function RightArrowIcon(props) {
	return _react2.default.createElement(
		'svg',
		props,
		_react2.default.createElement(
			'g',
			{
				transform: 'rotate(90 4.5 4.5)',
				fill: '#3F5060',
				fillRule: 'evenodd'
			},
			_react2.default.createElement('rect', {
				transform: 'scale(-1 1) rotate(-45 0 15.243)',
				x: '3.464',
				y: '-.536',
				width: '2',
				height: '10',
				rx: '1'
			}),
			_react2.default.createElement('rect', {
				transform: 'scale(-1 1) rotate(45 0 -19.94)',
				x: '9.103',
				y: '-.548',
				width: '2',
				height: '10',
				rx: '1'
			})
		)
	);
};

RightArrowIcon.defaultProps = {
	width: '9',
	height: '15',
	viewBox: '0 0 9 15',
	xmlns: 'http://www.w3.org/2000/svg'
};

var UpArrowIcon = function UpArrowIcon(props) {
	return _react2.default.createElement(
		'svg',
		props,
		_react2.default.createElement(
			'g',
			{
				fill: '#3F5060',
				fillRule: 'evenodd'
			},
			_react2.default.createElement('rect', {
				transform: 'scale(1 -1) rotate(-45 -6.314 0)',
				x: '3.464',
				y: '-.536',
				width: '2',
				height: '10',
				rx: '1'
			}),
			_react2.default.createElement('rect', {
				transform: 'scale(1 -1) rotate(45 20.852 0)',
				x: '9.103',
				y: '-.548',
				width: '2',
				height: '10',
				rx: '1'
			})
		)
	);
};

UpArrowIcon.defaultProps = {
	width: '15',
	height: '9',
	viewBox: '0 0 15 9',
	xmlns: 'http://www.w3.org/2000/svg'
};

var Arrow = function (_React$Component) {
	_inherits(Arrow, _React$Component);

	function Arrow() {
		_classCallCheck(this, Arrow);

		return _possibleConstructorReturn(this, (Arrow.__proto__ || Object.getPrototypeOf(Arrow)).apply(this, arguments));
	}

	_createClass(Arrow, [{
		key: 'render',
		value: function render() {
			switch (this.props.direction) {
				case 'left':
					return _react2.default.createElement(LeftArrowIcon, null);
				case 'right':
					return _react2.default.createElement(RightArrowIcon, null);
				case 'up':
					return _react2.default.createElement(UpArrowIcon, null);
				case 'down':
				default:
					return _react2.default.createElement(
						'svg',
						{ width: '15px', height: '9px', viewBox: '0 0 15 9', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
						_react2.default.createElement('defs', null),
						_react2.default.createElement(
							'g',
							{ id: 'atom/arrow/down/default', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
							_react2.default.createElement(
								'g',
								{ fill: this.props.color || '#3F5060' },
								_react2.default.createElement('rect', { id: 'Rectangle-5', transform: 'translate(4.464466, 4.464466) rotate(-45.000000) translate(-4.464466, -4.464466) ', x: '3.46446609', y: '-0.535533906', width: '2', height: '10', rx: '1' }),
								_react2.default.createElement('rect', { id: 'Rectangle-5-Copy', transform: 'translate(10.103436, 4.452278) rotate(-315.000000) translate(-10.103436, -4.452278) ', x: '9.10343624', y: '-0.547721569', width: '2', height: '10', rx: '1' })
							)
						)
					);
			}
		}
	}]);

	return Arrow;
}(_react2.default.Component);

exports.default = Arrow;